const settings = {
  namespaced: true, //开启命名空间
  state: {
  isRouterAlive: true, //控制路由显示（用于刷新页面）
	jumpCheckPrjID:'',//选择的项目ID
	isJump:true,//跳转模式
  },

  mutations: {
    RELOAD_ROUTER(state) {
		state.isRouterAlive = false;
		this._vm.$nextTick(() => {
		  state.isRouterAlive = true;
		});
	  },
	  SET_PRJID(state,prjId) {
		state.jumpCheckPrjID = prjId;
	  },
	  SET_JUMP_STATUS(state,status) {
		state.isJump = status;
	  },
  },

  actions: {
    // // 登录
    // Login({
    //   commit
    // }, userInfo) {
    //   commit('SET_TOKEN', 1)
    // },

  }
}

export default settings
